import Button from '@mui/material/Button';

const Header = () => {
    return (
        <>
            <header style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <div style={{ width: "80%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "25px 0" }}>
                    <div>
                        <img src="assets/Logo_Contblack_FundoEscuro.png" alt="Logo Contblack" />
                    </div>
                    <div>
                        <Button variant="outlined"
                            sx={{
                                backgroundColor: "#1EFF86", //9C01B9
                                borderRadius: "17px 0 17px 0",
                                fontSize: "0.7rem",
                                color: "black",
                                fontWeight: 800,
                                border: "none",
                                transition: "0.3s ease",
                                '&:hover': {
                                    backgroundColor: "#9C01B9",
                                    boxShadow: "0 4px 10px #9C01B9",
                                }
                            }}
                            onClick={() => window.open("https://contblack.com.br/", "_blank")}
                            >Site contblack</Button>
                    </div>
                </div>
            </header>
            <div style={{ width: "100%", height: "1px", backgroundColor: "white" }}></div>
        </>
    );
}

export default Header;